import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_app/crm/settings/')({
	beforeLoad: () => {
		throw redirect({ to: '/crm/settings/contact-fields' });
	},
});
